module.exports = __webpack_public_path__ + "static/media/sql_db.00458468.svg";